import React from "react";
import cn from "classnames";
import {createUseStyles} from "react-jss";
import {brandColor, defaultFontSize, disabledTextColor, primaryTextColor, secondaryTextColor} from "~/theme";
import PropTypes from "prop-types";


const UIInput = React.forwardRef(({className, large, small, ...props}, ref) => {
  const classes = useStyles();

  return (
    <input
      ref={ref}
      className={cn(classes.root, {
        [classes.large]: large,
        [classes.small]: small
      }, className)}
      {...props}
    />
  )
});

UIInput.propTypes = {
  large: PropTypes.bool,
  small: PropTypes.bool,

  value: PropTypes.any,
  onChange: PropTypes.func,
};

export default UIInput;

const useStyles = createUseStyles({
  root: {
    display: 'block',
    boxSizing: 'border-box',
    width: '100%',
    height: 32,
    padding: [[4, 14]],
    fontSize: defaultFontSize,
    color: primaryTextColor,
    background: '#fff',
    border: [[1, 'solid', '#BBB']],
    borderRadius: 4,
    transition: [['border-color', '0.15s', 'ease']],
    fontFamily: ["Helvetica Neue", 'Helvetica', 'Arial', 'sans-serif'],

    '&:-webkit-autofill::first-line': {
      fontFamily: ["Helvetica Neue", 'Helvetica', 'Arial', 'sans-serif'],
      fontSize: defaultFontSize,
    },

    '&::placeholder': {
      color: secondaryTextColor,
    },

    '&:focus': {
      borderColor: brandColor,
      outline: 0,
      boxShadow: [[0, 0, 2, brandColor]]
    },

    '&:disabled': {
      color: secondaryTextColor,
      borderColor: '#ccc',

      '&::placeholder': {
        color: disabledTextColor,
      },
    }
  },

  large: {
    height: 44,
  },

  small: {
    height: 28,
    padding: [[4, 8]],
  },
});
